import { ResolutionsEnum } from '@/main/services/enum/ResolutionsEnum';

const colors = {
  pantoneBlack: '#181F26',
  pantone2726C: '#3F5EC9',
  pantone2727C: '#3A7DE4',
  pantone2190C: '#55B4E8',
  pantone642C: '#CDDAE6',
  pantone656C: '#ECF1F6',
  pantone657C: '#161A1D',
  headerColor: '#181f26',
  // common colors
  red: '#f44336',
  green: '#00cc33',
  orange: '#ff9900',
  yellow: '#ffcc00',
  white: '#ffffff',
  grayLight: '#f8f8f8',
  grayDark: '#cccccc',
  black: "#000",
  grayDarker: '#e1e1e1',
  // Functional colors
  hoverGray: '#ECF1F4',
  errorLight: '#fdecea',
  errorDark: '#d32f2f',
  icon: '#7e7e7e',
  disabled: '#d7d7d7d7',
  neutral: {
    n0: "#FFFFFF",
    n50: "#FAFAFA",
    n100: "#F3F4F6",
    n200: "#E5E7EB",
    n300: "#D1D5DB",
    n400: "#9CA3AF",
    n500: "#6B7280",
    n600: "#55616C",
    n700: "#374151",
    n800: "#1F2937",
    n900: "#111827",
    n950: "#030712",
  },
  // figma colors
	figma: {
		system: {
			primary: "#941B80",
			secondary: "#0096AE",
			text: "#111827",
			contrast: "#FFFFFF",
			surface: "#FAFAFA",
			background: "#FFFFFF",
			success: "#088767",
			alert: "#F07406",
			error: "#DE242A",
			info: "#2563EB",
		},
		primary: {
			light: "#FFEFFC",
			base: "#941B80",
			dark: "#500443",
			darkest: "#34032B",
		},
		secondary: {
			light: "#EAFCFF",
			base: "#0096AE",
			dark: "#00505C",
			darkest: "#00343C",
		},
		neutral: {
			n0: "#FFFFFF",
			n50: "#FAFAFA",
			n100: "#F3F4F6",
			n200: "#E5E7EB",
			n300: "#D1D5DB",
			n400: "#9CA3AF",
			n500: "#6B7280",
			n600: "#55616C",
			n700: "#374151",
			n800: "#1F2937",
			n900: "#111827",
			n950: "#030712",
		},
		gray: {
			n600: "#535862",
			n700: "#414651",
		},
		alert: {
			light: "#FFF3D4",
		},
	},
  // params
  breakpoints: {
    mobile: `${ResolutionsEnum.mobile}px`,
    tablet: `${ResolutionsEnum.tablet}px`,
    desktop: `${ResolutionsEnum.desktop}px`,
    desktopSmall: `${ResolutionsEnum.desktopSmall}px`,
    desktopLarge: `${ResolutionsEnum.desktopLarge}px`,
    desktopWide: `${ResolutionsEnum.desktopWide}px`,
    desktopExtraWide: `${ResolutionsEnum.desktopExtraWide}px`
  }
};

export default colors;
